import { useEffect } from "react";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";

// The homepage's display serif (self-hosted, so no third-party font request).
// Cormorant Garamond is small enough to ship up front; each CJK face declares
// over a hundred unicode-range slices per weight, so only the active
// language's stylesheet is fetched, and the browser then downloads just the
// slices the visible text uses. If a chunk fails, the fallback serif stays.
const CJK_SERIF_LOADERS = {
  zh: () => import("@fontsource/noto-serif-tc/500.css"),
  ja: () => import("@fontsource/noto-serif-jp/500.css"),
};

/** Loads the CJK display serif for `language` (see `--home-serif` in HomePage). */
export default function useHomeSerifFont(language) {
  useEffect(() => {
    CJK_SERIF_LOADERS[language]?.().catch(() => {});
  }, [language]);
}
